import { formatearColones } from '@adelante/shared';

interface MontoColonesProps {
  monto: number | null | undefined;
  className?: string;
}

/** Monto en colones con formato es-CR (Flujo Semanal) — distinto de <MontoCRC> (en-US, Vencimientos). */
export function MontoColones({ monto, className }: MontoColonesProps) {
  if (monto === null || monto === undefined) return <span className={className}>—</span>;
  return <span className={className}>{formatearColones(monto)}</span>;
}
